import { useState, useEffect, useCallback, useRef } from 'react';

import { useVideoFromMas } from '../VideoPlayer/hooks/useMediaAssetService';

import type { EditorialContent } from '@cobalt/utilities';
import MatchHighlightsServiceInstance from '@services/MatchHighlightsService';
import type { Match } from '@shared-types/match.types';

const useMatchHighlight = (match: Match, enabled: boolean) => {
  const inited = useRef(false);
  const context = useRef(null);
  const savedMatch = useRef<Match>(match);
  const [video, setVideo] = useState<EditorialContent>(null);

  const stopPolling = useCallback(() => {
    MatchHighlightsServiceInstance.off([savedMatch.current.id], setVideo, context);
    inited.current = false;
  }, []);

  const startPolling = useCallback(() => {
    if (inited.current || !savedMatch.current?.id) return;
    stopPolling();

    MatchHighlightsServiceInstance.on([savedMatch.current.id], setVideo, context);
    inited.current = true;
  }, [stopPolling]);

  useEffect(() => {
    savedMatch.current = match;
    enabled ? startPolling() : stopPolling();
  }, [enabled, match, startPolling, stopPolling]);

  return useVideoFromMas(video);
};

export default useMatchHighlight;
